import React, { useEffect, useState } from 'react'
import Search from '../../../../components/uiComponent/inputs/searchinput';
import Select from "../../../../components/uiComponent/select/index";
import { PoHistoryMobileWrapper , ModalWrapper} from './style'
import Modal from '../../../../components/uiComponent/modal/index'


import PoCardItem from '../../../../components/uiComponent/PoCardItem';
import PoDetailsMobile from '../PoDetailsMobile';
import { getPoUsers, getWarehousePos, SetPoState, UpdatePo } from '../../../../slices/po';
import { useDispatch, useSelector } from 'react-redux';
import { debounce, trim } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
const { STORAGE_ICON_URL } = require('../../../../constants/storage');
const MarkAsResolved = `${STORAGE_ICON_URL}/mark-as-resolved-icon.svg`;

const PoHistoryMobile = () => {

  const dispatch = useDispatch();
  const [page, setPage] = useState({ pageSize: 25, pageNumber: 1 });
  const [filters, setFilters] = useState({ search: '', first_name: '' });
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [id, setId] = useState(null)
  const [sortBy, setSortBy] = useState({ key: '', type: '' });
  const navigation = useNavigate();

  const {
    warehousePos = [],
    poUsers = [],
    totalWarehousePosCount,
    fetchingWarehousePos
  } = useSelector(state => state.pos);
  const { currentUser } = useSelector(state => state.auth || {});
  useEffect(() => {
    dispatch(getPoUsers());
    dispatch(SetPoState({
      field: 'mobileReceivingHeading',
      value: 'Purchase Orders'
    }));
  }, []);

  useEffect(() => {
    dispatch(getWarehousePos({ page, filters, screenType: 'mobile' }));
  }, [filters, page]);

  const handleClose = ()=>{
    setIsModalOpen(false)
  }

  const handlePoUpdate = ()=>{
    setIsModalOpen(false);
    dispatch(UpdatePo({ poId:String(id), status:"Arrived" })).then(()=>{
      dispatch(getWarehousePos({ page, filters, screenType: 'mobile' }));
    })
    
 }

  const users = [
    { value: 'user', label: 'user1' },
    { value: 'users', label: 'user2' },
  ];

  const poItems = Array.from({ length: 20 }, (_, index) => ({
    id: index + 1,
    userName: `User ${index + 1}`,
    userEmail: `user${index + 1}@example.com`,
    poName: `PO_${index + 1}_December 16`,
    vendor: `Vendor ${index + 1}`,
    status: index % 2 === 0 ? 'Receiving' : 'Confirmed',
    totalInvoiceQty: Math.floor(Math.random() * 1000) + 1,
  }));

  const handleSearchPo = debounce((value) => {
    if (trim(value) || filters.search) {
      setFilters((prev) => ({
        ...prev,
        search: trim(value)
      }));
    }
  }, 800);

  const handleGetPoDetails = (id) => {
    return navigation(`/po-details-mobile/${id}`);
  };

  const handleFilterChange = ({ key, value }) => {
    setPage({ pageSize: 25, pageNumber: 1 });
    setFilters(filters => ({ ...filters, [key]: value }));
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10 && (warehousePos?.length < totalWarehousePosCount) && !fetchingWarehousePos) {
      setPage((prev) => ({
        ...prev,
        pageSize: prev?.pageSize + 25
      }));
    }
  };

  return (
    <PoHistoryMobileWrapper>
      <header>
        <Search
          className="search"
          placeholder="Search by PO Name"
          onChange={({ target }) => { handleSearchPo(target?.value) }}
        />
        {
          currentUser?.role?.id !== 5 && (
            <Select
              isClearable={true}
              placeholder="Filter by user"
              className="mb-0"
              // loading={() => {}}
              options={poUsers}
              onChange={(e) => handleFilterChange({ key: 'user_id', value: e?.value })}
            />
          ) 
        }
      </header>
      <Spin tip='Loading..' spinning={fetchingWarehousePos}>
        <section onScroll={handleScroll}>
          {warehousePos?.map((item) => (
            <PoCardItem
              key={item.id}
              userName={item?.user?.first_name || 'N/A'}
              userEmail={item?.user?.email || 'N/A'}
              poName={item?.file_name || ''}
              vendor={item?.vendor?.name || ''}
              status={item?.status || 'N/A'}
              totalInvoiceQty={item.invoice_quantity}
              receivedQty = {item.received_quantity}
              setIsModalOpen= {setIsModalOpen}
              setId={()=>setId(item.id)}
              onClick={() => handleGetPoDetails(item.id)}
              cardClick={() => handleGetPoDetails(item.id)}
            />
          ))}
          {
             !warehousePos?.length && (<span className="mb-0 h-100 d-flex justify-content-center align-items-center w-100" style={{ color: 'grey', fontSize: '16px' }}>
              No Record Found
            </span>)}
        </section>
      </Spin>
      {/* <PoDetailsMobile /> */}
      <Modal
        open={isModalOpen}
        onClose={handleClose}
        onHide={handleClose}
        closeText='Cancel'
        saveText='Confirm'
        header='Arrived Confirmation'
        className='delete-confirmation-modal'
        closeButton={true}
        onSave={handlePoUpdate}
      >
        <ModalWrapper>
          <div className='delete-modal-wrapper'>
            <img src={MarkAsResolved} alt='WarningIcon' title='WarningIcon' />
            <h3>Mark As Arrived</h3>           
              <p>Do You Mark This PO As Arrived ?</p>
          </div>
          </ModalWrapper>
      </Modal>
    </PoHistoryMobileWrapper>
  )
}

export default PoHistoryMobile;
